/**
 * Semantic state → chip color mapping for index pages. Colors derive from
 * meaning (via keyword heuristics), not specific state codes, so new states
 * inherit sensible colors. See docs/expandable-index-pages.md.
 */
export type SemanticColor = 'success' | 'error' | 'warning' | 'info' | 'default';

export const semanticStateColor = (state: string | null | undefined): SemanticColor => {
  if (!state) return 'default';
  // FLAG covers the order state `FLAGGED`. Without it the one state that means "this order needs
  // attention" fell through to a grey `default`, reading as unremarkable on the Orders list.
  if (/REJECTED|DAMAGED|MISSING|SHRINK|LOST|PROBLEM|WRONG|CANCEL|FAIL|VOID|DECLINE|REFUND|FLAG/.test(state)) return 'error';
  // ISSUED covers REISSUED too. A gift card in either state is spendable, which the table in
  // docs/expandable-index-pages.md maps to success — without it the most common state on the
  // page fell through to a grey `default`, reading as inactive.
  if (/APPROVED|CURATED$|COMPLETE|FULFILLED|DELIVERED|PAID|CAPTURED|SUCCESS|ISSUED/.test(state)) return 'success';
  if (/ORDERED|PICK|PACK|SHIPPED|DROPPED|TRANSIT|PROCESSING|FULFILL/.test(state)) return 'info';
  // AUTH rather than AUTHORIZED, so the gift card state `AUTH` matches as well. AUTH_FAILED is
  // already claimed by FAIL in the error branch above, which runs first.
  if (/PENDING|NEEDS|REVIEW|IN_PROGRESS|HOLD|CLEANING|REPAIR|AUTH|PARTIAL|OPEN/.test(state)) return 'warning';
  return 'default';
};
